"use client";

import {
  createContext, ReactNode, useContext 
} from "react";

const ServerContext = createContext({
  isMobileOnServer: true,
});

interface Props {
  initialState: {
    isMobileOnServer: boolean;
  };
  children: ReactNode;
}

const ServerContextProvider = (props: Props) => {
  const {
    initialState, children 
  } = props;

  return <ServerContext.Provider value={initialState}>{children}</ServerContext.Provider>;
};

export default ServerContextProvider;

export const useServerContext = () => useContext(ServerContext);
